import React from 'react'
import clsx from 'clsx'
import {useLocation} from 'react-router'
import {checkIsActive, KTIcon, WithChildren} from '../../../../helpers'
import {useLayout} from '../../../core'
import { Link } from "react-router-dom";

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean,
  count: any,
  isOpen?: any,
  setIsOpen?: any
}

const SidebarMenuItemWithSub: React.FC<Props & WithChildren> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet,
  count,
  isOpen,
  setIsOpen
}) => {
  const {pathname} = useLocation()
  const isActive = checkIsActive(pathname, to)
  const {config} = useLayout()
  const {app} = config

  return (
    <div
      className={clsx('menu-item', 'menu-accordion')}
      // data-kt-menu-trigger='click'
    >
      <span className={clsx('menu-link', {active: isActive})}>
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
      <Link to={to} className='d-flex w-100' style={{ flexGrow: 0, marginRight: 'auto' }}>
        {icon && app?.sidebar?.default?.menu?.iconType === 'svg' && (
          <span className='menu-icon'>
            <KTIcon iconName={icon} className='fs-2' />
          </span>
        )}
        {fontIcon && app?.sidebar?.default?.menu?.iconType === 'font' && (
          <i className={clsx('bi fs-3', fontIcon)}></i>
        )}
        <span className='menu-title'>{title}</span>
        {count && <span className='badge badge-yellow mx-2'>{count}</span>}
        </Link>
        <span className='menu-arrow'
        style={{ width: '12px', height: '12px'}}
        onClick={() => {
          setIsOpen({
            status: isOpen.status && isOpen.name === title ? false : true,
            name: title,
          })
        }}
        ></span>
      </span>
      <div className={clsx('menu-sub menu-sub-accordion', {'show': isOpen.status && isOpen.name === title}, {'menu-active-bg': isActive})}>
        {children}
      </div>
    </div>
  )
}

export {SidebarMenuItemWithSub}
